import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'

interface UnsavedChangesDialogProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const UnsavedChangesDialog = ({ open, onConfirm, onCancel }: UnsavedChangesDialogProps) => {
  const { t } = useTranslate()

  return (
    <ConfirmationDialog
      open={open}
      title={t('unsavedChanges', 'Unsaved Changes')}
      message={t(
        'unsavedChangesAllocationRulesMessage',
        'You have unsaved allocation rule changes. Continuing will discard them.',
      )}
      primaryActionText={t('discardAndContinue', 'Discard and Continue')}
      closeLabel={t('cancel', 'Cancel')}
      onClose={onCancel}
      onConfirm={onConfirm}
      maxWidth='xs'
      blockClickOutside
    />
  )
}
